// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

const isSqlQuery = objectOf({
  id: string,
  report_name: string,
  report_id: string,
  created_at: string,
  user: string,
  status: string,
  sql: string,
  result_count: number,
});

export const isSqlQueriesResult = objectOf({
  reports: arrayOf(isSqlQuery),
});
